import { useMemo } from "react";

const useAssessmentItems = () => {

    const assessmentItems = useMemo(
        () => [
            {
                title: "",
                type: "preformAssessment"
            },
            {
                title: "כניסה לאבחון דרך המערכת של המורה",
                type: "preformAssessmentTable"
            },
            {
                title: "ביצוע האבחון",
                type: "preformAssessmentSteps"
            },
        ], []
    )

    return assessmentItems
}

export default useAssessmentItems